module.exports = __webpack_public_path__ + "static/media/v45.c68f987a.mp4";